
import * as React from 'react';
import axios from 'axios';
import { getCookies } from "cookies-next";
import ImageUploading from 'react-images-uploading';
import PageIcon from '@rsuite/icons/Page';


import { config } from '../../data/config';
import Swal from 'sweetalert2';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import { Input } from 'rsuite';
import FileUploader from '../tools/uploaderfiles';
import ChunkedFileUpload from '../tools/chunkupload';

const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";

type LanguageCode = string;
export default function TissMusic({ data, reload, activeLang = 'en' }: { data: any; reload: () => void; activeLang?: LanguageCode }) {
    const { t } = useTranslation();

    let cookie = getCookies();

    const [newitem, setItemEdit] = React.useState(data.toimage == null ? false : true);
    const [show, setShow] = React.useState(true);
    const [text, setText] = React.useState(data!.data!=undefined ? data!.data.html :'');

    const startedit = () => {
        setItemEdit(true);
        setShow(false);
    }
    const backtopreviw = () => {
        setItemEdit(true);
        setShow(true);
    }
    const inputHandler = (event:any, editor:any) => {
        setShow(editor.getData())
        setText(editor.getData())
    };
    const save = async () => {

        try {
            var path = `${config.url}/v1/dashboard/component/texteditor/${data._id}`;

            let res = await axios({
                method: 'put',
                data: {
                    html: text
                },
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('update');
        } catch (error) {

        }
    }
    return (
        <div className='w-[100%] p-4' dir='ltr'>
          
            {
                <div>

                        {

                            <div className='text-center flex flex-col gap-3 align-center'>

                                <ChunkedFileUpload id={data.id} component={'Music'}></ChunkedFileUpload>

                               
                                <Input

                                        defaultValue={data!.data!=undefined ? data!.data.html :''}
                                        as={`textarea`}
                                        cols={5}
                                        className={`${inputstyle}   text-right `}
                                        placeholder="توضیحات"
                                        onChange={(e) => setText(e) }
                                    />

                                <div className='mt-3 flex gap-4' dir='rtl'>
                                    <button onClick={(e) => {
                                        save();
                                    }} className=" hover:bg-blue-700  hover:text-white text-black font-bold  px-4 border border-blue-700 rounded">
                                       {t('Apply')} 
                                    </button>

                                </div>
                              
                            </div>
                        }
                    </div>
            }


        </div>
    )
}